var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66699C5.40829 1.66699 1.66663 5.40866 1.66663 10.0003C1.66663 14.592 5.40829 18.3337 9.99996 18.3337C14.5916 18.3337 18.3333 14.592 18.3333 10.0003C18.3333 5.40866 14.5916 1.66699 9.99996 1.66699ZM13.3333 10.6253H10.625V13.3337C10.625 13.6753 10.3416 13.9587 9.99996 13.9587C9.65829 13.9587 9.37496 13.6753 9.37496 13.3337V10.6253H6.66663C6.32496 10.6253 6.04163 10.342 6.04163 10.0003C6.04163 9.65866 6.32496 9.37533 6.66663 9.37533H9.37496V6.66699C9.37496 6.32533 9.65829 6.04199 9.99996 6.04199C10.3416 6.04199 10.625 6.32533 10.625 6.66699V9.37533H13.3333C13.675 9.37533 13.9583 9.65866 13.9583 10.0003C13.9583 10.342 13.675 10.6253 13.3333 10.6253Z",
    fill: "#0FA072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddField);
export default __webpack_public_path__ + "static/media/addField.75e7928fdb645e952be23a5f0124d92d.svg";
export { ForwardRef as ReactComponent };